import React, { useState } from "react";
import { fetchWithAuth } from "../services/api";
import { useLoading } from "../contexts/GlobalStateContext";

const ChangePassword = ({ onPasswordChanged }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const { loading, setLoading } = useLoading();

  const handleChangePassword = async () => {
    setLoading(true);
    try {
      const response = await fetchWithAuth("/api/authorization/changepassword", {
        method: "POST",
        body: JSON.stringify({
          oldPassword,
          newPassword,
        }),
      });

      if (response.ok) {
        setStatusMessage("Lösenordet är bytt");
        setOldPassword("");
        setNewPassword("");
        if (onPasswordChanged) onPasswordChanged(newPassword);
      } else {
        const data = await response.json();
        setStatusMessage(data?.message || "Misslyckades med lösenordsbyte");
      }
    } catch (error) {
      setStatusMessage("Fel vid lösenordsbyte");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <hr className="tw-border-black tw-border tw-mt-2" />
      <div className="tw-flex tw-flex-col tw-gap-2">
        <div>
          <label
            htmlFor="oldPassword"
            className="tw-block tw-mb-1 tw-text-lg tw-font-semibold"
          >
            Nuvarande lösenord:
          </label>
          <input
            id="oldPassword"
            type="password"
            placeholder="Nuvarande lösenord"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            className="tw-w-full tw-border tw-rounded tw-px-3 tw-py-2 tw-text-lg tw-font-semibold"
          />
        </div>
        <div>
          <label
            htmlFor="newPassword"
            className="tw-block tw-mb-1 tw-text-lg tw-font-semibold"
          >
            Nytt lösenord:
          </label>
          <input
            id="newPassword"
            type="password"
            placeholder="Nytt lösenord"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            className="tw-w-full tw-border tw-rounded tw-px-3 tw-py-2 tw-text-lg tw-font-semibold"
          />
        </div>
        <button
          type="button"
          onClick={handleChangePassword}
          disabled={loading}
          className={`tw-self-start tw-px-4 tw-py-2 tw-rounded-lg tw-font-medium
            ${loading
              ? "tw-bg-yellow-300 tw-text-black tw-opacity-70 tw-cursor-not-allowed"
              : "tw-bg-yellow-500 tw-text-black hover:tw-bg-yellow-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-yellow-400"
            }`}
        >
          {loading ? "Byter..." : "Byt lösenord"}
        </button>
        <div className="status-message tw-min-h-[10px]">{statusMessage}</div>
      </div>
    </>
  );
}

export default ChangePassword;